<template>
  <div>
    <div id="video-container" class="video-container">
      
  </div>
 
  <button v-if="showReturnButton" class="return-button" @click="request_yuzhidian">返回预置点</button>
  <div class="overlay-image" v-if="shouldShowImage" :style="{ backgroundImage: `url(${imgUrl}?t=${new Date().getTime()})` }">
    <img class="overlay-image2" v-if="shouldShowImage && imgUrl2" :src="`${imgUrl2}?t=${new Date().getTime()}`" :style="{ top:`${imgPosition.xtop}px`, left: `${imgPosition.xleft}px`, width: `${imgPosition.xwidth}%` }">
  </div>
  
  <div class="overlay-image" v-if="showImage1" :style="{ backgroundImage: `url(${imgUrl1}?t=${new Date().getTime()})` }"></div>
  <div class="overlay-identifying" v-if="isIdentifying">
      <div class="identifying-text">识别中...</div>
      <div class="spinner"></div>
    </div>
  <!-- 设备离线弹窗 -->
  <div v-if="deviceOffline" class="modal-overlay" @click="closeModal">
      <div class="modal-content" @click.stop>
        <span class="close-button" @click="closeModal">&times;</span>
        <p>该设备目前不可用</p>
      </div>
    </div>
    <!-- 动态渲染识别框 -->
    <BboxContainer :bbox="bbox" :shouldShowImage="shouldShowImage" :w="w" :h="h"/>
     
    <button class="toggle-button" @click="toggleAutoStop">{{ autoStop ? '关闭' : '打开' }}自动停止</button>
    <div v-if="showPauseIcon" class="pause-icon" @click="continuePlay">
    </div>
    
    
    <!-- <div>
      <button v-on:click="init">init</button>
      <button v-on:click="stop">stop</button>
      <button v-on:click="play">play</button>
      <button v-on:click="openSound">openSound</button>
      <button v-on:click="closeSound">closeSound</button>
      <button v-on:click="startSave">startSave</button>
      <button v-on:click="stopSave">stopSave</button>
      <button v-on:click="capturePicture">capturePicture</button>
      <button v-on:click="fullScreen">fullScreen</button>
      <button v-on:click="getOSDTime">getOSDTime</button>
      <button v-on:click="ezopenStartTalk">开始对讲</button>
      <button v-on:click="ezopenStopTalk">结束对讲</button>
      <button v-on:click="destroy">销毁</button>
    </div> -->
  </div>
</template>

<script>
import EZUIKit from "ezuikit-js";
import BboxContainer from "./BboxContainer.vue";
var player = null;

export default {
  name: "HelloWorld",
  components: {
    BboxContainer,
  },
  data() {
    return {
      videoUrl: "ezopen://open.ys7.com/AH9537567/1.hd.live",
      imgUrl: null,
      imgUrl1: null,
      cameraStandId: null,
      showImage: false,
      showImages: false,
      showImage1: false,
      token: null,
      bbox: null,
      deviceOffline: false,
      showReturnButton: false,

      w: 1920,
      h: 1080,
      isIdentifying: false,
      tokenInfo: {
        accessToken: "",
        expiresAt: 0,
      },
      highlightedBboxIndex: null,
      autoStop: true, // 默认打开自动停止功能
      stopTimer: null, // 定时器
      showPauseIcon: false, // 是否显示暂停图标

      imgUrl2: null, // 用于显示列表图片
      imgPosition: {
        xtop: 0,
        xleft: 0,
        xwidth: 0,
      },//图片位置
    

    };
  },
  props: {
    msg: String,
  },
  computed: {
    shouldShowImage() {
      return this.showImage && this.showImages;
    },
  },
  mounted() {
    this.getParamsFromHash();
    this.handleHashChange();
    
    console.log("videoUrl", this.videoUrl);
    this.showOverlay = true; 
    console.group("mounted 组件挂载完毕状态===============》");
    //添加ablclick事件监听器
    document.addEventListener("dblclick", this.handleDoubleClick);
    this.init();
    this.getBbox(this.cameraStandId)
  },
  created: () => {
    
    console.group("created 组件创建完毕状态===============》");
  },
  beforeDestroy() {
    //移除监听事件
    document.removeEventListener("dblclick", this.handleDoubleClick);
    window.removeEventListener("hashchange", this.handleHashChange);
  },
  watch: {
    videoUrl(newUrl, oldUrl) {
      console.log("旧的videoUrl", oldUrl);
      console.log("新的videoUrl", newUrl);
      console.log("videoUrl", newUrl !== "undefined");
      //新的视频地址改变，并且新的地址不为undefined，执行初始化播放器
      if (newUrl !== oldUrl && newUrl !== "undefined") {
        this.deviceOffline = false;
        console.log("播放器初始化==================", newUrl);
        this.init();
        this.getBbox(this.cameraStandId)
      }
    },
    imgUrl(newUrl, oldUrl) {
      console.log("新的imgUrl", newUrl);
      if (newUrl !== oldUrl && newUrl !== "undefined") {
        if(newUrl === "identifying"){
          console.log("开始识别");
          // setTimeout(() => {
          //   this.isIdentifying = true; 
          // }, 6000); // 延迟 ms 显示识别中动画
          
        }else {
          this.getBbox(this.cameraStandId)
          setTimeout(() => {
            this.showImage = true; // 延迟几秒后显示图片
          }, 1500); // 延迟 3 秒
        }
      }
    }
  },
  methods: {
    toggleAutoStop() {
      this.autoStop = !this.autoStop;
      if (!this.autoStop) {
        console.log("停止自动停止播放==================");
        this.clearStopTimer();
      }
      if (this.autoStop) {
        this.startStopTimer();
      }
    },
    startStopTimer() {
      console.log("开始自动停止播放==================");
      this.clearStopTimer();
      if (this.autoStop) {
        this.stopTimer = setTimeout(() => {
          if (this.autoStop) {
            this.destroy();
            this.showImages = false;
            this.clearStopTimer();
            this.showImage = false;
            this.showImage1 = false;
            console.log("自动停止播放==================-- 60 --==");
            this.showPauseIcon = true;
          }
        }, 60000); // 30秒
      }
    },
    clearStopTimer() {
      console.log("清除自动停止播放==================");
      if (this.stopTimer) {
        clearTimeout(this.stopTimer);
        console.log("清除自动停止播放==================ok");
        this.stopTimer = null;
      }
    },
    continuePlay() {
      console.log("继续播放==================");
      this.showPauseIcon = false;
      this.init();
      this.getBbox(this.cameraStandId)
      setTimeout(() => {
            this.showImage = true; // 延迟几秒后显示图片
          }, 1000); // 延迟 3 秒
      this.startStopTimer();
    },
    
    async request_yuzhidian() {
      console.log("返回预置点=============");
      this.showImage1 = false;
      this.showReturnButton = false;
      const url = new URL("https://gyl.huidao.tech:10443/move/camera");
      url.search = new URLSearchParams({
        value: this.cameraStandId
      }).toString();

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      console.log("response", response);
      this.showImage = true;
      this.showImage1 = false;
      return response.json();
    },
  
    handleDoubleClick(e) {
      const x = event.clientX;
      const y = event.clientY;
      console.log("======点击了：", x, y);
      console.log("======点击了：", this.cameraStandId);
      this.fangda(x, y)
    },
    async fangda(x, y) {
      x = x * this.w / 928;
      y = y * this.h / 522;
      console.log("机位号" + this.cameraStandId);
      console.log("x", this.bbox);
      console.log("点击的位置：" + x + "," + y);
      console.log("this.bbox", this.bbox);
      if (this.bbox === null || this.bbox.length === 0) {
          await this.getBbox(this.cameraStandId);
        }
      for(const bbox of this.bbox) {
        const [x1, y1, x2, y2] = bbox.rel_coordinate.split(",");
        console.log("x1", x1, "x2", x2, "y1", y1, "y2", y2);

        if (x >= x1 && x <= x2 && y >= y1 && y <= y2){
          const data = {
            "value": this.cameraStandId,
            "sri": bbox.storage_racks_id,
            "zb": bbox.rel_coordinate
          }
          console.log("点击后" + bbox);
          this.request_fangda(data).then(res => {
            console.log("res", res);
            this.imgUrl1 = res.result;
            console.log("this.imgUrl", this.imgUrl1)
            this.showImage1 = true;
            this.showReturnButton = true;
          });
          console.log("开始识别");
          this.showImage = false;
          setTimeout(() => {
            this.isIdentifying = true; 
          }, 6000); // 延迟 ms 显示识别中动画
          
         break;
        }
      }
    },
    async request_fangda(data) {
      console.log("data", data);
      const url = new URL("https://gyl.huidao.tech:10443/move/camera2");
      url.search = new URLSearchParams({
        value: data['value'],
        sri: data['sri'],
        zb: data['zb']
      }).toString();

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      this.isIdentifying = false;
      return response.json();
    },
    async getToken() {
      try {
        const tokenUrl = "/api/jeecg-boot/sys/mLogin"; // 假设这是获取Token的URL
        const response = await fetch(tokenUrl, {
          method: 'POST',
          headers: {
            "Accept": "*/*",
            "Accept-Encoding": "gzip, deflate, br",
            "User-Agent": "PostmanRuntime-ApipostRuntime/1.1.0",
            "Connection": "keep-alive",
            "Content-Type": "application/json",
            "Cache-Control": "no-cache",
            "Host": "47.100.115.107:8080"
          },
          body: JSON.stringify({
            username: 'liyafei',
            password: 'Aa!23456'
          })
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("tokenInfo", data);
        this.token = data.result.token; // 假设Token在响应的token字段中
        return this.token;
      } catch (error) {
        console.error("Error fetching token:", error);
        throw error;
      }
    },
    async getBbox(cameraStandId) {

      console.log("机位号" + cameraStandId);
      console.log(cameraStandId.slice(-2));
      if (cameraStandId.slice(-2) === "00") {
        console.log("枪机不画框，机位号," + cameraStandId);
        return
      }
      try {
        if (!this.token) {
          await this.getToken();
        }
        const baseUrl = "/api/jeecg-boot/online/cgform/api/getData";
        const endpoint = "/e667c6a23ab94df78c4c46adc9498448";
        const queryParams = new URLSearchParams({
          _t: Date.now(),
          column: "id",
          order: "desc",
          pageNo: 1,
          pageSize: 50,
          superQueryMatchType: "and",
          superQueryParams: JSON.stringify([{ rule: "eq", type: "text", val: cameraStandId, field: "camera_stand_id" },
                                            { rule: "ne", type: "text", val: "0", field: "goods_num" }])
        });

        const url = `${baseUrl}${endpoint}?${queryParams.toString()}`;
        const response = await fetch(url,{
          method: 'GET',
          headers: {
           'X-Access-Token': `${this.token}`,
          'Content-Type': 'application/json',
          'Accept': 'application/json'
          }

        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        console.log("货架框---data", data);
        const bboxs = data.result.records.map(record => ({
          rel_coordinate: record.rel_coordinate,
          storage_racks_id: record.storage_racks_id
        }));
        console.log("货架框---bboxs", bboxs);
        this.bbox = bboxs;
        return data;
      } catch (error) {
        console.error("Error fetching bbox data:", error);
        // 可以选择抛出异常或返回默认值
        throw error;
      }
    },
    handleHashChange() {
      window.addEventListener("hashchange", () => {
        console.log("hashchange事件触发");
        this.showReturnButton = false;
        this.showImage = false;
        this.showImage1 = false;
        this.isIdentifying = false;
        this.showPauseIcon = false;
        this.bbox = null;
        this.getParamsFromHash();
      });
    },
    getParamsFromHash() {
      const hashParams = new URLSearchParams(window.location.hash.slice(1));
      const videoUrl = hashParams.get('videoUrl');
      const imgUrl = hashParams.get('imgUrl');
      const cameraStandId = hashParams.get('cameraStandId');
      const imgUrl2 = hashParams.get('imgUrl2');
      const imgPosition = hashParams.get('imgPosition');
      console.log("videoUrl改变：", videoUrl);
      console.log("imgUrl改变：", imgUrl);
      console.log("imgUrl2改变：", imgUrl2)
      console.log("imgPosition改变：", imgPosition)
      console.log("cameraStandId改变：", cameraStandId);
      if (videoUrl && videoUrl !== "undefined") {
        this.videoUrl = videoUrl;
        this.cameraStandId = cameraStandId;
        const firstDigit = parseInt(cameraStandId.charAt(0), 10)
        this.w = 1920;
        this.h = 1088;
        switch(firstDigit) {
          case 1:
            this.w = 2560;
            this.h = 1440;
            break;
          case 2:
            this.w = 3200;
            this.h = 1800;
            break;
          
        }
      }
      if (imgUrl && imgUrl !== "undefined") {
        this.imgUrl = imgUrl;
        this.imgUrl2 = imgUrl2;
        
        this.imgPosition.xtop = parseInt(imgPosition.split(",")[0]);
        this.imgPosition.xleft = parseInt(imgPosition.split(",")[1]);
        this.imgPosition.xwidth = parseInt(imgPosition.split(",")[2]);
        console.log("图片2顶部距离", this.imgPosition.xtop);
        console.log("图片2左侧距离", this.imgPosition.xleft);
        console.log("图片2宽度", this.imgPosition.xwidth);
      } else {
        console.error('No video URL found in query parameters.呵呵');
      }
    },
    // getVideoUrlFromQuery() {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const videoUrl = urlParams.get('videoUrl');  // 假设查询参数名为 videoUrl
    //   const imgUrl = urlParams.get('imgUrl');
    //   console.log("videoUrl", videoUrl);
    //   console.log("imgUrl", imgUrl);
    //   if (videoUrl && imgUrl) {
    //     this.videoUrl = videoUrl;
    //     this.imgUrl = imgUrl;
    //     console.log("videoUrl", videoUrl);
    //     console.log("imgUrl", imgUrl);
    //     this.showOverlay = true;
    //   } else {
    //     console.error('No video URL found in query parameters.呵呵');
    //   }
    // },
    fetchToken() {
      const params = {
        'appKey': '1e1a17b71fda435385d25f173af8ae56',
        "appSecret": 'f7718f1e6a7a0c7b1be7bb2f7c2d70c1',
      };
      console.log("params", params);
      return fetch("https://open.ys7.com/api/lapp/token/get", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(params)
      })
      .then((response) => response.json())
      .then((res) => {
        console.log("res", res);
        this.tokenInfo.accessToken = res.data.accessToken;
        this.tokenInfo.expiresAt = Date.now() + 7 * 24 * 60 * 60 * 1000; // 设置过期时间为7天后
        console.log("accessToken", this.tokenInfo.accessToken);
        return this.tokenInfo.accessToken;
      });
    },
    ensureToken() {
      if (!this.tokenInfo.accessToken || this.tokenInfo.expiresAt <= Date.now()) {
        console.log("ensureToken=======================");
        return this.fetchToken();
      }
      console.log("tokenInfo=============", this.tokenInfo);
      return Promise.resolve(this.tokenInfo.accessToken);
    },
    getStatus(accessToken) {
      const channel = this.videoUrl.split('/')[3];
      const params = {
        'deviceSerial': channel,
        "accessToken": accessToken,
      };
      console.log("params", params);
      return fetch("https://open.ys7.com/api/lapp/device/info", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams(params)
      })
      .then((response) => response.json())
      .then((res) => {
        console.log("res", res);
        console.log("res.data.status", res.data.status);
        return res.data.status;
      });
    },
    init() {
      this.startStopTimer();
      if (player) {
        this.showImages = false;
        this.destroy();
      }
      console.log("init=======================");

      this.ensureToken().then((accessToken) => {
          console.log("accessToken", accessToken),
          console.log("url", this.videoUrl);
          this.getStatus(accessToken).then((status) => {
            console.log("status", status);
            if (status === 1){
              const container = document.getElementById("video-container");
              const w1 = container.clientWidth;
              const h1 = container.clientHeight;
              console.log("width", w1);
              console.log("height", h1);
              player = new EZUIKit.EZUIKitPlayer({
                id: "video-container", // 视频容器ID
                accessToken: accessToken,
                url: this.videoUrl,
                // simple: 极简版; pcLive: pc直播; pcRec: pc回放; mobileLive: 移动端直播; mobileRec: 移动端回放;security: 安防版; voice: 语音版;
                template: "simple",
                // plugin: ["talk"], // 加载插件，talk-对讲
                width: w1,
                height: h1,
                handleError: (error) => {
                  console.error("handleError", error);
                },
                // language: "en", // zh | en
                // staticPath: "/ezuikit_static", // 如果想使用本地静态资源，请复制根目录下ezuikit_static 到当前目录下， 然后设置该值
              });
              this.showImages = true;
              window.player = player;
            }
            if (status === 0){
              console.log("设备离线");
              this.showImage = false;
              this.showImage1 = false;
              this.showOverlay = false;
              this.deviceOffline = true;
            }
          });
         
        });
    },
    play() {
      var playPromise = player.play();
      playPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    stop() {
      var stopPromise = player.stop();
      stopPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    getOSDTime() {
      var getOSDTimePromise = player.getOSDTime();
      getOSDTimePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    capturePicture() {
      var capturePicturePromise = player.capturePicture(
        `${new Date().getTime()}`
      );
      capturePicturePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    openSound() {
      var openSoundPromise = player.openSound();
      openSoundPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    closeSound() {
      var openSoundPromise = player.closeSound();
      openSoundPromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    startSave() {
      var startSavePromise = player.startSave(`${new Date().getTime()}`);
      startSavePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    stopSave() {
      var stopSavePromise = player.stopSave();
      stopSavePromise.then((data) => {
        console.log("promise 获取 数据", data);
      });
    },
    ezopenStartTalk() {
      player.startTalk();
    },
    ezopenStopTalk() {
      player.stopTalk();
    },
    fullScreen() {
      player.fullScreen();
    },
    destroy() {
      var destroyPromise = player.destroy();
      destroyPromise.then((data) => {
        console.log("promise 获取 数据", data);    
      });
      player = null;
    },
    closeModal() {
      this.deviceOffline = false;
    },

  },
};
</script>
<style scoped>

.video-container {
  position: relative;
  width: 100vww; /* 使用百分比 */
  height: 100vh; /* 使用百分比 */
  max-width: 928px; /* 设置最大宽度 */
  max-height: 522px; /* 设置最大高度 */
}
@media (min-width: 900px) {
  .video-container{
    width: 928px;
  }
}

.overlay-image {
  position: absolute;
  top: 8px;
  left: 9px;
  margin-right: 0;
  width: 928px;
  height: 522px;
  background-size: cover;
  background-position: center;
  opacity: 0.9; /* 可以调整透明度 */
  z-index: 10; /* 确保覆盖在视频上方 */
}
@media (min-width: 948px) {
  .overlay-image {
    left: 50%;
    transform: translateX(-50%);
    margin-left: 0;
    margin-right: 0;
  }
}

@media (max-width: 948px) {
  .overlay-image {
    left: 9px;
  }
}
.overlay-image2 {
  position: absolute;
  margin-right: 0;
  background-size: cover;
  background-position: center;
  width: 15%;
  height: auto;
  object-fit: contain;
  opacity: 1; /* 可以调整透明度 */
  z-index: 12; /* 确保覆盖在视频上方 */
  background-color: transparent;
  border: none
}
.overlay-identifying {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  z-index: 11; /* 确保覆盖在视频和图片上方 */
}

.identifying-text {
  font-size: 24px;
  margin-bottom: 20px;
}

.spinner {
  border: 16px solid rgba(255, 255, 255, 0.3);
  border-top: 16px solid white;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.return-button {
  position: absolute;
  top: 470px;
  left: 50%;
  margin-left: 0;
  margin-right: 0;
  width: 92px;
  height: 52px;
  background-size: cover;
  background-position: center;
  opacity: 0.9; /* 可以调整透明度 */
  z-index: 15; /* 确保覆盖在视频上方 */
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 调整背景颜色的透明度 */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 12; /* 确保覆盖在视频和图片上方 */
}

.modal-content {
  background-color: white;
  width: 40%; /* 增加宽度 */
  max-width: 500px; /* 最大宽度 */
  padding: 40px;
  border-radius: 20px; /* 增加圆角 */
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2); /* 添加阴影效果 */
  text-align: center;
  position: relative;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  font-size: 30px; /* 增加字体大小 */
  color: #333; /* 设置字体颜色 */
  background: none; /* 去掉背景 */
  border: none; /* 去掉边框 */
  outline: none; /* 去掉轮廓 */
}

.close-button:hover {
  color: #ff4d4f; /* 鼠标悬停时改变颜色 */
}
.bbox-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 14;
  /* 确保识别框不影响其他元素的点击事件 */
}

.bbox {
  position: absolute;
  border: 50px solid red;
  transition: border-color 0.3s;
}

.bbox.highlight {
  border-color: greenyellow; /* 高亮颜色 */
}
.toggle-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 16;
  background: none;
  border: none;
  cursor: pointer;
  padding: 10px 20px;
  font-size: 14px;
  color: white;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  opacity: 0; /* 默认隐藏 */
  transition: opacity 0.3s;
}

.toggle-button:hover{
  opacity: 1; /* 悬停时显示 */
}

.pause-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  font-size: 20px;
  cursor: pointer;
  z-index: 17;
}
.pause-icon::before {
  content: '';
  width: 0;
  height: 0;
  border-left: 20px solid white;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
}

.pause-icon:hover {
  background-color: rgba(0, 0, 0, 0.9);
}
</style>